import { authHeader } from "../_helpers";
import { handleResponse } from "../_helpers/response";
import config from "../config";
const baseUrl = config.apiGateway.baseUrl;
export const VendorService = {
  addAPIDetails,
  addVendor,
  listVendor,
  listAPIDetails,
  addMapApi,
  listMapApiDetails,
  addApi,
  getApiConfigs,
};
function addAPIDetails(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };
  return fetch(`${baseUrl}/criminal/addapi`, requestOptions).then(
    handleResponse
  );
}
function addVendor(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };
  return fetch(`${baseUrl}/criminal/addvendor`, requestOptions).then(
    handleResponse
  );
}
function listVendor() {
  const requestOptions = {
    method: "GET",
    headers: {
      ...authHeader(),
    },
  };
  return fetch(`${baseUrl}/criminal/listVendor`, requestOptions).then(
    handleResponse
  );
}
function listAPIDetails() {
  const requestOptions = {
    method: "GET",
    headers: {
      ...authHeader(),
    },
  };
  return fetch(`${baseUrl}/criminal/listApiDetails`, requestOptions).then(
    handleResponse
  );
}
function addMapApi(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };
  return fetch(`${baseUrl}/criminal/addMapApi`, requestOptions).then(
    handleResponse
  );
}
function listMapApiDetails() {
  const requestOptions = {
    method: "GET",
    headers: {
      ...authHeader(),
    },
  };
  return fetch(`${baseUrl}/criminal/listMapApiDetails`, requestOptions).then(
    handleResponse
  );
}
function addApi(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };
  return fetch(`${baseUrl}/criminal/createAPI/`, requestOptions).then(
    handleResponse
  );
}
function getApiConfigs(){
  const requestOptions = {
    method: "GET",
    headers: {
      ...authHeader(),
    },
  };
  return fetch(`${baseUrl}/criminal/getApiConfigs`, requestOptions).then(
    handleResponse
  ); 
}